import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import Translation from '../../lang/Translation';
import isUsingArtemisStyles from '../../selectors/isUsingArtemisStyles';
import useStyles from './ImportTaxHelpContent.styles';

const importTaxHelpContentPrefix = 'deliveryOptions.import.tax.help.content';

export function ImportTaxHelpContent(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});

  const getChineseOnlyString = props.chineseLanguage ? '.chineseLanguage' : '';

  const getTitle = (sectionNumber, suffix) => (
    <h3 className={classes.sectionHeader} data-test="ImportTaxHelpContent__sectionHeader">
      {`${sectionNumber}. `}
      <Translation>{`${importTaxHelpContentPrefix}.title.${suffix}${getChineseOnlyString}`}</Translation>
    </h3>
  );

  const getParagraph = suffix => (
    <p>
      <Translation>{`${importTaxHelpContentPrefix}.paragraph.${suffix}${getChineseOnlyString}`}</Translation>
    </p>
  );

  const getBullet = suffix => (
    <li>
      <Translation>{`${importTaxHelpContentPrefix}.bullet.${suffix}${getChineseOnlyString}`}</Translation>
    </li>
  );

  return (
    <div className={classes.importTaxHelpContent} data-test="ImportTaxHelpContent">
      {/* First parameter of getTitle is the section number to display */}
      {/* eg 2. Resident ID requirements */}
      {getTitle(1, 'generalInformation')}
      <ul>
        {getBullet('generalInformation.1')}
        {getBullet('generalInformation.2')}
      </ul>

      {getTitle(2, 'residentIDRequirements')}
      <ul>
        {getBullet('residentIDRequirements.1')}
        {getBullet('residentIDRequirements.2')}
        {getBullet('residentIDRequirements.3')}
        {getBullet('residentIDRequirements.4')}
      </ul>

      {getParagraph('residentIDRequirements.1')}
      {getParagraph('residentIDRequirements.2')}

      {getTitle(3, 'howTaxesAreCalculated')}
      <ul>
        {getBullet('howTaxesAreCalculated.1')}
        {getBullet('howTaxesAreCalculated.2')}
        {getBullet('howTaxesAreCalculated.3')}
      </ul>

      {getTitle(4, 'understandingAllowances')}
      {getParagraph('understandingAllowances')}
    </div>
  );
}

const mapStateToProps = state => ({
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

ImportTaxHelpContent.propTypes = {
  chineseLanguage: PropTypes.bool,
  isUsingArtemisStyles: PropTypes.bool,
};

export default connect(mapStateToProps)(ImportTaxHelpContent);
